import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {clearEntityCards} from '~entity/entity-card/entity-card.actions';
import {authReiniciar} from '~feature/feature-auth/feature-auth.actions';
import {clearEntityRotas} from '~entity/entity-rota/entity-rota.actions';
import {mapClear} from '~feature/feature-map/feature-map.actions';
import {resumoReiniciar} from '~feature/feature-resumo/feature-resumo.actions';
import { ActionCreator } from '@ngrx/store'; // TypedAction removido, não faz parte da API pública do NgRx 18
import {clearEntityDocumentos} from '~entity/entity-documento/entity-documento.actions';
import {clearEntityIndicadores} from '~entity/entity-indicador/entity-indicador.actions';
import {clearUpdatedsIds} from '~entity/entity-update/entity-update.actions';
import {appClear} from '~feature/feature-app/feature-app.actions';

@Injectable({
  providedIn: 'root',
})
export class ReduxService {

  private readonly clearAuthActions: ActionCreator[];
  private readonly clearDataActions: ActionCreator[];

  constructor(private readonly store: Store) {
    this.clearAuthActions = [
      authReiniciar,
      appClear,
    ];
    this.clearDataActions = [
      clearEntityCards,
      clearEntityRotas,
      clearEntityDocumentos,
      clearEntityIndicadores,
      clearUpdatedsIds,
      mapClear,
      resumoReiniciar,
    ];
  }

  reset(onlyData?: boolean): void {
    const clearActions = this.clearDataActions.concat(onlyData ? [] : this.clearAuthActions);
    clearActions.forEach((action) => this.store.dispatch(action() as any));
  }
}
